module.exports = __webpack_public_path__ + "static/img/feature_1.0c50b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/feature_1.png
// module id = M/jg
// module chunks = 0